<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-08-27 20:06:49
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-10-26 20:32:23
 * @FilePath: /b2c_public_components/src/zz-report/src/quality-vr.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<style lang="scss" scoped>
  .new-quality-wrap {
    height: 290px;
    width: 100%;
    background-position: top left;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
    .img {
      width: 94px;
      height: 94px;
      // border: 1px solid rgba(255, 255, 255, 0.4);
      background: #000;
      opacity: 0.4;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -60px;
      margin-left: -47px;
    }
    .vr-img {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 90px;
      width: 90px;
      margin-top: -58px;
      margin-left: -45px;
      z-index: 10;
    }
  }
</style>

<template>
  <div
    v-zpm="{ sectionid: 120, areaexposure: 120, sortname: '质检vr点击' }"
    v-lazy:backgroundImage="$setPicSize(dataInfo.qualityDesc, 686)"
    class="new-quality-wrap"
    @click="gotoVr"
  >
    <div class="img"></div>
    <img
      class="vr-img"
      :src="
        $setPicSize(
          'https://pic4.zhuanstatic.com/zhuanzh/0919f210-311c-4a7d-8183-49ed4453118a.gif',
          94,
          94
        )
      "
      alt=""
    />
  </div>
</template>
<script>
  import { skipToUrl } from '../../utils/native'
  import { setPicSize } from '@zz-common/zz-utils'
  export default {
    props: {
      dataInfo: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
    },
    methods: {
      gotoVr() {
        const url = 'https://m.zhuanzhuan.com/u/online-activities/vr/index.html?needHideHead=3'
        skipToUrl({
          targetUrl: url,
        })
      },
    },
  }
</script>
